function checkIfItemExists(array) {
  if (Array.isArray(array) && array.length > 0) {
    return true;
  } else {
    return false;
  }
}
function dateFormatsForRowColumnAndSort(format) {
  switch (format) {
    case "Year":
    case "Years":
    case "year":
    case "years":
      return "%Y";
    case "Quarter":
    case "Quarters":
    case "quarter":
    case "quarters":
      return "Qx";
    case "month":
    case "months":
    case "Month":
    case "Months":
      return "%M";
    case "Week":
    case "Weeks":
    case "week":
    case "weeks":
      return "Wx";
    case "day":
    case "days":
    case "Day":
    case "Days":
      return "%d";

    default:
      console.error("format is different from above cases");
      return (format = null); // Explicitly set the format to null for unsupported values
  }
}
function dateUnitForRowColumnAndSort(format) {
  switch (format) {
    case "Year":
    case "Years":
    case "year":
    case "years":
      return "Year";
    case "Quarter":
    case "Quarters":
    case "quarter":
    case "quarters":
      return "Quarter";
    case "month":
    case "months":
    case "Month":
    case "Months":
      return "Month";
    case "Week":
    case "Weeks":
    case "week":
    case "weeks":
      return "Week";
    case "day":
    case "days":
    case "Day":
    case "Days":
      return "Day";

    default:
      console.error("format is different from above cases");
      return (format = null); // Explicitly set the format to null for unsupported values
  }
}
function filterDateFormats(format) {
  console.log(format);
  switch (format) {
    case "Year":
    case "Years":
    case "year":
    case "years":
      return "YYYY";
    case "Quarter":
    case "Quarters":
    case "quarter":
    case "quarters":
      return "Qx-Fyyyyy-yy";
    case "month":
    case "months":
    case "Month":
    case "Months":
      return "MMMM";
    case "day":
    case "days":
    case "Day":
    case "Days":
      return "dd-mm-yyyy";
    default:
      console.error("format is different from above cases");
      return null; // Explicitly set the format to null for unsupported values
  }
}
function relativeDateUnit(format) {
  switch (format) {
    case "Year":
    case "Years":
    case "year":
    case "years":
      return "Years";
    case "Quarter":
    case "Quarters":
    case "quarter":
    case "quarters":
      return "Quarters";
    case "month":
    case "months":
    case "Month":
    case "Months":
      return "Months";
    case "Week":
    case "Weeks":
    case "week":
    case "weeks":
      return "Weeks";
    case "day":
    case "days":
    case "Day":
    case "Days":
      return "Days";
    default:
      console.log("format is different from above cases");
      return null; // Explicitly set the format to null for unsupported values
  }
}
function dateUnitForBuildQueryFromThisDateToThisDate(filterDateUnit) {
  console.log(filterDateUnit);
  switch (filterDateUnit) {
    case "Year":
    case "Years":
    case "year":
    case "years":
      return "Year";
    case "Quarter":
    case "Quarters":
    case "quarter":
    case "quarters":
      return "Quarter";
    case "month":
    case "months":
    case "Month":
    case "Months":
      return "Month";
    case "Week":
    case "Weeks":
    case "week":
    case "weeks":
      return "Week";
    case "day":
    case "days":
    case "Day":
    case "Days":
      return "Day";
    default:
      console.log("format is different from above cases");
      return null; // Explicitly set the format to null for unsupported values
  }
}
function modifiedQuery(query, vizType) {
  let { rows, groupByFields } = query;
  console.log(query);
  if (
    rows.length === 0 &&
    groupByFields.length > 0 &&
    ["simpleTable", "table"].includes(vizType)
  ) {
    console.log("group item in rows for table");

    // Separate groupByFields into date and non-date items
    const nonDateFields = [];
    const dateFields = [];

    groupByFields.forEach((gItem) => {
      if (gItem.dataType !== "Date") {
        nonDateFields.push(gItem);
      } else {
        dateFields.push(gItem);
      }
    });

    // Assign non-date items to rows and date fields back to groupByFields
    rows = nonDateFields;
    groupByFields = dateFields;
  } else if (
    query.rows.length > 0 &&
    query.groupByFields.length === 0 &&
    vizType !== "simpleTable"
  ) {
    console.log("row item in group for not table");
    // Separate groupByFields into date and non-date items
    const nonDateFields = [];
    const dateFields = [];

    rows.forEach((rItem) => {
      if (rows.length === 1) {
        dateFields.push(rItem);
      } else {
        if (rItem.dataType !== "Date") {
          nonDateFields.push(rItem);
        } else {
          dateFields.push(rItem);
        }
      }
    });

    // Assign non-date items to rows and date fields back to groupByFields
    rows = nonDateFields;
    groupByFields = dateFields;
  }
  return { ...query, rows, groupByFields };
}
function modifiedSort(sort, query) {
  let { valueColumns, groupByFields } = query;
  let requiredSort = sort[0];
  console.log(requiredSort);

  const modifiedSortIs = valueColumns.find((vItem) => {
    if (vItem.dataType === "Number") {
      return `${vItem.measure.value}_${vItem.rename}` === requiredSort.column;
    }
  });
  console.log(modifiedSortIs);
  if (requiredSort.dataType === "Number" && valueColumns.length > 0) {
    if (modifiedSortIs) {
      if (groupByFields.length > 0) {
        requiredSort = {
          ...requiredSort,
          column: `Total ${modifiedSortIs.measure.value}_${modifiedSortIs.rename}`,
        };
      } else {
        return [requiredSort];
      }
    }
    console.log(requiredSort);
    return [requiredSort];
  } else {
    console.log(requiredSort);
    return [requiredSort];
  }
}
function lastAndNextDates(period, unit) {
  console.log(period, unit);
  // day
  if (["day", "days", "Day", "Days"].includes(unit) && period === "Last") {
    console.log("I ran");
    return "Yesterday";
  }
  if (["day", "days", "Day", "Days"].includes(unit) && period === "Next") {
    console.log("I ran");
    return "Tomorrow";
  }
  //week
  if (["Week", "Weeks", "week", "weeks"].includes(unit) && period === "Last") {
    console.log("I ran");
    return "Last Week";
  }
  if (["Week", "Weeks", "week", "weeks"].includes(unit) && period === "Next") {
    console.log("I ran");
    return "Next Week";
  }
  // month
  if (
    ["month", "months", "Month", "Months"].includes(unit) &&
    period === "Last"
  ) {
    console.log("I ran");
    return "Last Month";
  }
  if (
    ["month", "months", "Month", "Months"].includes(unit) &&
    period === "Next"
  ) {
    console.log("I ran");
    return "Next Month";
  }
  // Quarter
  if (
    ["Quarter", "Quarters", "quarter", "quarters"].includes(unit) &&
    period === "Last"
  ) {
    console.log("I ran");
    return "Last Quarter";
  }
  if (
    ["Quarter", "Quarters", "quarter", "quarters"].includes(unit) &&
    period === "Next"
  ) {
    console.log("I ran");
    return "Next Quarter";
  }
  // year
  if (["Year", "Years", "year", "years"].includes(unit) && period === "Last") {
    console.log("I ran");
    return "Last Year";
  }
  if (["Year", "Years", "year", "years"].includes(unit) && period === "Next") {
    console.log("I ran");
    return "Next Year";
  }
}
function nowDates(period, unit) {
  // day
  if (["day", "days", "Day", "Days"].includes(unit) && period === "This") {
    console.log("I ran");
    return "Today";
  }
  //week
  if (["Week", "Weeks", "week", "weeks"].includes(unit) && period === "This") {
    console.log("I ran");
    return "This Week";
  }
  // month
  if (
    ["month", "months", "Month", "Months"].includes(unit) &&
    period === "This"
  ) {
    console.log("I ran");
    return "This Month";
  }
  // Quarter
  if (
    ["Quarter", "Quarters", "quarter", "quarters"].includes(unit) &&
    period === "This"
  ) {
    console.log("I ran");
    return "This Quarter";
  }
  // year
  if (["Year", "Years", "year", "years"].includes(unit) && period === "This") {
    console.log("I ran");
    return "This Year";
  }
}
function VizType(visualization) {
  console.log(visualization);
  switch (visualization) {
    case "Table":
      return "simpleTable";
    case "Bar Chart":
      return "stackedbarchart";
    case "Pie Chart":
      return "piechart";
    case "Line Chart":
      return "linechart";
    case "Area Chart":
      return "areachart";
    default:
      console.error(`${visualization} is different from above cases`);
      return null;
  }
}
const measureOptionObjects = [
  {
    label: "Sum",
    value: "SUM",
  },

  {
    label: "Max",
    value: "MAX",
  },
  {
    label: "Min",
    value: "MIN",
  },
  {
    label: "Avg",
    value: "AVG",
  },

  {
    label: "Count",
    value: "COUNT",
  },
  {
    label: "Count Distinct",
    value: "DISTINCT",
  },
  {
    label: "No Calculation",
    value: "calculatedField",
  },
  {
    label: "No Calculation",
    value: "NOCALCULATION",
  },
];

export {
  checkIfItemExists,
  dateFormatsForRowColumnAndSort,
  dateUnitForRowColumnAndSort,
  filterDateFormats,
  relativeDateUnit,
  dateUnitForBuildQueryFromThisDateToThisDate,
  modifiedQuery,
  modifiedSort,
  lastAndNextDates,
  nowDates,
  VizType,
  measureOptionObjects,
};
